/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useEffect, useState } from 'react';
import { useParams, NavLink } from 'react-router-dom';
import YouTube from 'react-youtube';
import Swal from 'sweetalert2';

// @mui material components
import Card from '@mui/material/Card';
import Icon from '@mui/material/Icon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Pagination from '@mui/material/Pagination';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import InputAdornment from '@mui/material/InputAdornment';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDSnackbar from 'components/MDSnackbar';
import MDInput from 'components/MDInput';
import MDCheckbox from 'components/MDCheckbox';
import MDSelect from 'components/MDSelect';
import TableHeader from 'components/Table/TableHeader';
import MDTypography from 'components/MDTypography';
import TabPanel from 'components/TabPanel/TabPanel';
import MDEditor from 'components/MDEditor';

// Material Dashboard 2 PRO React examples
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import Navbar from 'examples/Navbars/NavBar';
import Footer from 'examples/Footer';
import { useTranslation } from 'react-i18next';
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import { useSelector } from 'react-redux';
import * as Func from 'services/Function';
import ProductUpload from './ProductUpload';
import ProductImage from './ProductImage';

const initAttr = {
  id: '',
  sku: '',
  cat_id: '',
  subcat_id: '',
  image_id: '',
  unit_id: '',
  unitadd_id: '',
  unitbuy_id: '',
  brand_id: '',
  color_id: '',
  barcode: '',
  vat_type: 'NO',
  image: '',
  name: '',
  name_en: '',
  detail: '',
  detail_en: '',
  content: '',
  content_en: '',
  drug_type_9: 'N',
  drug_type_10: 'N',
  drug_type_11: 'N',
  autoid: 'Y',
  autoprefix: 'RT',
  cost: '',
  price: '',
  youtube: '',
  min_stock: '0',
  max_stock: '999999',
  check_stock: 'N',
  active_buy: 'Y',
  change_unit: 'Y',
  enable: 'Y',
  created_at: '',
  updated_at: '',
};

const initNavigate = {
  first: '',
  prev: '',
  next: '',
  last: '',
};

const initFind = {
  search: '',
  order_by: 'tb.id',
  order_sort: 'desc',
  page: 1,
  perPage: 10,
  pageTotal: 0,
};

function ProductRawmat() {
  const mod = 'product_rawmat';
  const app = useSelector((state) => state[APP_STATE]);
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [pageTotal, setPageTotal] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [record, setRecord] = useState([]);
  const [show, setShow] = useState(null);
  const [attr, setAttr] = useState(initAttr);
  const [find, setFind] = useState(initFind);
  const [navigate, setNavigate] = useState(initNavigate);
  const [notify, setNotify] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState(initFind.order_sort);
  const [orderBy, setOrderBy] = useState(initFind.order_by);
  const [modalAdd, setModalAdd] = useState(false);
  const [cboCat, setCboCat] = useState([]);
  const [cboSubCat, setCboSubCat] = useState([]);
  const [cboBrand, setCboBrand] = useState([]);
  const [cboUnit, setCboUnit] = useState([]);
  const [image, setImage] = useState([]);
  const [tab, setTab] = useState(0);

  const openShow = (e) => setShow(e.currentTarget);
  const closeShow = () => setShow(null);

  const initHeader = [
    { id: 'tb.id', label: t(`attr.id`), align: 'center' },
    { id: 'tb.image_id', label: t(`attr.image`), align: 'center' },
    { id: 'tb.barcode', label: 'Barcode', align: 'left' },
    { id: 'tb.sku', label: 'รหัสสินค้า', align: 'left' },
    { id: 'tb.name', label: 'ชื่อสินค้า', align: 'left' },
    { id: 'tb.brand_id', label: 'ยี่ห้อ', align: 'left' },
    { id: 'tb.cat_id', label: 'หมวดหมู่', align: 'left' },
    { id: 'tb.unit_id', label: 'หน่วย', align: 'left' },
    { id: 'tb.cost', label: 'ราคาซื้อ', align: 'right' },
    { id: 'tb.price', label: 'ราคาขาย', align: 'right' },
    { id: 'tb.min_stock', label: 'Min/Max', align: 'center' },
    { id: 'tb.enable', label: t(`attr.enable`), align: 'center' },
  ];

  const showNotify = (msg, color) => {
    setNotify(
      <MDSnackbar
        color={color}
        icon='notifications'
        title={t(`app.name`)}
        content={msg}
        dateTime={Func.dateTimeDisplay()}
        open={Boolean(true)}
        close={() => setNotify(!notify)}
      />
    );

    setTimeout(function () {
      setNotify(null);
    }, 3000);
  };

  const view = (data) => {
    setFind(data);
    setLoading(true);
    closeShow();

    FetchData('POST', `/${mod}`, app.token, {
      lang: app.lang,
      search: data.search,
      page: data.page,
      per_page: data.perPage,
      orderby: data.order_by,
      ordersort: data.order_sort,
    }).then((result) => {
      if (result.status === 'ok') {
        setRecord(result.data);

        setPageTotal(result.total_pages);
        setPageNo(result.page);
      }
      setLoading(false);
    });
  };

  const open = () => {
    setLoading(true);
    setConfirm(false);
    setAttr(initAttr);
    setTab(0);

    FetchData('GET', `/${mod}/${id}`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === 'ok') {
        setNavigate(result.navigate);
        setAttr(result.data);
        setImage(result.image);

        setLoading(false);
      }
    });
  };

  const addConfirm = () => {
    if (attr.autoid === 'N' && !Func.verifyLength(attr.sku, 1)) return;
    if (
      attr.autoid === 'N' &&
      Func.verifyLength(attr.sku, 1) &&
      !['RT', 'SV', 'TS'].some((p) => (attr.sku || '').toUpperCase().startsWith(p))
    ) {
      showNotify('รหัสสินค้า (SKU) ต้องขึ้นต้นด้วย RT, SV หรือ TS เท่านั้น', 'error');
      return;
    }
    if (!Func.verifyLength(attr.name, 1)) return;
    if (!Func.verifyLength(attr.unit_id, 1)) return;

    setConfirm(true);
  };

  const add = () => {
    setLoading(true);
    setModalAdd(false);

    FetchData('PUT', `/${mod}`, app.token, {
      cat_id: attr.cat_id,
      subcat_id: attr.subcat_id,
      unitadd_id: attr.unitadd_id,
      unitbuy_id: attr.unitbuy_id,
      brand_id: attr.brand_id,
      color_id: attr.color_id,
      sku: attr.sku,
      barcode: attr.barcode,
      name: attr.name,
      cost: attr.cost,
      price: attr.price,
      unit_id: attr.unit_id,
      min_stock: attr.min_stock,
      max_stock: attr.max_stock,
      check_stock: attr.check_stock,
      enable: attr.enable,
      autoid: attr.autoid,
      autoprefix: attr.autoprefix.toUpperCase(),
    }).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        window.location.replace(`${mod}/${result.id}`);
        showNotify(t(`alert.addcomplete`), 'success');
      } else {
        setModalAdd(true);
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const editConfirm = () => {
    if (!Func.verifyLength(attr.cat_id, 1)) return false;
    if (!Func.verifyLength(attr.sku, 1)) return false;
    if (!['RT', 'SV', 'TS'].some((p) => (attr.sku || '').toUpperCase().startsWith(p))) {
      showNotify('รหัสสินค้า (SKU) ต้องขึ้นต้นด้วย RT, SV หรือ TS เท่านั้น', 'error');
      return false;
    }
    if (!Func.verifyLength(attr.name, 1)) return false;
    if (!Func.verifyLength(attr.unit_id, 1)) return false;

    return true;
  };

  const edit = () => {
    if (!editConfirm()) return;

    Swal.fire({
      title: t(`alert.confirm_edit_title`),
      icon: 'warning',
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: t(`element.save`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: '#dc3545',
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);
        setConfirm(false);

        FetchData('PATCH', `/${mod}/${attr.id}`, app.token, {
          cat_id: attr.cat_id,
          subcat_id: attr.subcat_id,
          unit_id: attr.unit_id,
          unitadd_id: attr.unitadd_id,
          unitbuy_id: attr.unitbuy_id,
          brand_id: attr.brand_id,
          color_id: attr.color_id,
          name: attr.name,
          enable: attr.enable,
        }).then((result) => {
          setLoading(false);

          if (result.status === 'ok') {
            showNotify(t(`alert.editcomplete`), 'success');
          } else {
            setConfirm(false);
            showNotify(t(`alert.${result.msg}`), 'error');
          }
        });
      }
    });
  };

  const upload = (filedata) => {
    setLoading(true);

    FetchData('OPTIONS', `/product/upload`, app.token, {
      id: id,
      filedata: filedata,
    }).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        setImage(result.image);
        showNotify(t(`alert.editcomplete`), 'success');
      } else {
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const pin = (item) => {
    setLoading(true);

    FetchData('OPTIONS', `/product/pin`, app.token, {
      id: item.id,
      image_id: item.image_id,
    }).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        setAttr({ ...attr, image: result.image.image });
        showNotify(t(`alert.editcomplete`), 'success');
      } else {
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const renderLoading = () => {
    return (
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
    );
  };

  const renderShow = (
    <Menu
      anchorEl={show}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      open={Boolean(show)}
      onClose={closeShow}
      keepMounted
    >
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 10 })}>
        {t(`element.show_record`, { num: 10 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 20 })}>
        {t(`element.show_record`, { num: 20 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 100 })}>
        {t(`element.show_record`, { num: 100 })}
      </MenuItem>
    </Menu>
  );

  const handleSort = (e, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);

    view({ ...find, order_by: property, order_sort: isAsc ? 'desc' : 'asc' });
  };

  const init = () => {
    FetchData('GET', `/${mod}`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === 'ok') {
        setAttr(initAttr);
        setCboCat(result.category);
        setCboSubCat(result.subcat);
        setCboBrand(result.brand);
        setCboUnit(result.unit);
        if (id === undefined) {
          view(find);
        } else {
          open();
        }
      } else {
        Func.exitApp();
      }
    });
  };

  const enableDisplay = (inp) => {
    if (inp === 'Y') return <Icon color='info'>verified</Icon>;
    return <Icon color='error'>not_interested</Icon>;
  };

  const btnOpen = (item) => {
    return (
      <NavLink to={`/${mod}/${item.id}`}>
        <MDButton
          variant='text'
          color='info'
          size='small'
          sx={{ fontSize: '1rem', whiteSpace: 'nowrap' }}
        >
          {item.barcode}
        </MDButton>
      </NavLink>
    );
  };

  const renderSearch = () => {
    return (
      <Card sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <MDBox
              noValidate
              component='form'
              role='form'
              onSubmit={(e) => {
                e.preventDefault();
                view({ ...find, period: 'ALL', page: 1 });
              }}
            >
              <MDInput
                name='searchform'
                fullWidth
                value={find.search}
                type='search'
                onChange={(e) => setFind({ ...find, search: e.target.value, page: 1 })}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position='start'>{t('element.search')} :</InputAdornment>
                  ),
                  autoComplete: 'off',
                }}
              />
            </MDBox>
          </Grid>
        </Grid>
      </Card>
    );
  };

  const stockDisplay = (item) => {
    if (item.check_stock === 'Y') {
      return (
        <MDBox>
          {Func.numberDisplay(item.min_stock)} - {Func.numberDisplay(item.max_stock)}
        </MDBox>
      );
    }
    return 'N/A';
  };

  const costDisplay = (item) => {
    if (item.cost * 1 > 0) {
      return Func.numberDisplay(item.cost);
    }
    return 'N/A';
  };

  const renderList = () => {
    return (
      <MDBox mb={7}>
        <Navbar route={[t(`menu.product`), t(`menu.product`)]} />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={9} md={10} lg={11}>
            {renderSearch()}
          </Grid>
          <Grid item xs={12} sm={3} md={2} lg={1}>
            <MDButton
              variant='contained'
              color='dark'
              size='large'
              fullWidth
              sx={{ pt: 1.6, pb: 1.6 }}
              onClick={() => {
                setAttr(initAttr);
                setConfirm(false);
                setModalAdd(true);
              }}
            >
              <Icon>post_add</Icon>
            </MDButton>
          </Grid>
          <Grid item xs={12}>
            <TableContainer component={Paper} sx={{ minHeight: 400 }}>
              <Table aria-label='datatable table'>
                <TableHeader
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleSort}
                  data={initHeader}
                />
                <TableBody>
                  {record.map((row) => (
                    <TableRow key={row.id} hover>
                      <TableCell align='center'>{row.id}</TableCell>
                      <TableCell align='center'>{Func.imageDisplay(row)}</TableCell>
                      <TableCell align='left'>{btnOpen(row)}</TableCell>
                      <TableCell align='left'>{row.sku}</TableCell>
                      <TableCell align='left' className='nowrap'>
                        {row.name}
                      </TableCell>
                      <TableCell align='left' className='nowrap'>
                        {row.brand_name}
                      </TableCell>
                      <TableCell align='left' className='nowrap'>
                        {row.cat_name}
                      </TableCell>
                      <TableCell align='left'>{row.unit_name}</TableCell>
                      <TableCell align='right' width={120}>
                        {costDisplay(row)}
                      </TableCell>
                      <TableCell align='right' width={120}>
                        {Func.numberDisplay(row.price)}
                      </TableCell>
                      <TableCell align='center' className='nowrap'>
                        {stockDisplay(row)}
                      </TableCell>
                      <TableCell align='center'>{enableDisplay(row.enable)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={12}>
            <Card sx={{ p: 2 }}>
              <MDBox display='flex' justifyContent='space-between' alignItems='flex-start'>
                <MDButton variant={show ? 'contained' : 'outlined'} color='dark' onClick={openShow}>
                  {t(`element.show_record`, { num: find.perPage })}&nbsp;
                  <Icon>keyboard_arrow_down</Icon>
                </MDButton>
                {renderShow}
                <Pagination
                  count={pageTotal}
                  variant='outlined'
                  color='secondary'
                  showFirstButton
                  showLastButton
                  page={pageNo}
                  onChange={(e, p) => view({ ...find, page: p })}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderProductInfo = () => {
    return id === undefined ? (
      <MDBox className='card' p={2} mb={2}>
        <MDTypography variant='h6' mb={3}>
          สินค้า
        </MDTypography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MDCheckbox
              label='สร้างรหัสอัตโนมัติ'
              checked={attr.autoid === 'Y'}
              onChange={(e) => setAttr({ ...attr, autoid: e.target.checked ? 'Y' : 'N' })}
            />
          </Grid>
          {attr.autoid === 'Y' ? null : (
            <Grid item xs={12}>
              <MDInput
                label='รหัสสินค้า *'
                onChange={(e) => setAttr({ ...attr, sku: e.target.value })}
                value={attr.sku}
                variant='standard'
                fullWidth
                inputProps={{
                  autoComplete: 'off',
                }}
              />
            </Grid>
          )}
          {attr.autoid === 'Y' ? (
            <Grid item xs={12}>
              <MDInput
                label='อักษรนำหน้า'
                onChange={(e) => setAttr({ ...attr, autoprefix: e.target.value })}
                value={attr.autoprefix}
                variant='standard'
                fullWidth
                inputProps={{
                  maxLength: 2,
                  autoComplete: 'off',
                  sx: { textTransform: 'uppercase' },
                }}
              />
            </Grid>
          ) : null}
          <Grid item xs={12}>
            <MDInput
              label='Barcode'
              onChange={(e) => setAttr({ ...attr, barcode: e.target.value })}
              value={attr.barcode}
              variant='standard'
              fullWidth
              inputProps={{
                maxLength: 20,
                autoComplete: 'off',
                placeholder: 'AUTO',
              }}
            />
          </Grid>
        </Grid>
      </MDBox>
    ) : (
      <MDBox className='card' p={2} mb={2}>
        <MDTypography variant='h6' mb={3}>
          สินค้า
        </MDTypography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {attr.image === '' ? null : <ProductImage parent={attr} callback={pin} size='large' />}
          </Grid>
          <Grid item xs={12}>
            <MDInput
              label='รหัสสินค้า'
              value={attr.sku}
              variant='standard'
              fullWidth
              inputProps={{
                readOnly: true,
                autoComplete: 'off',
              }}
            />
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderPriceInfo = () => {
    return (
      <MDBox className='card' p={2}>
        <MDTypography variant='h6' mb={3}>
          ราคา (Standard)
        </MDTypography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MDInput
              label='ราคาทุน'
              onFocus={(e) => e.target.select()}
              onChange={(e) => setAttr({ ...attr, cost: e.target.value })}
              value={attr.cost}
              variant='standard'
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <MDTypography variant='body'>บาท</MDTypography>
                  </InputAdornment>
                ),
                inputProps: {
                  className: 'text-right',
                  autoComplete: 'off',
                },
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <MDInput
              label='ราคาขาย'
              onFocus={(e) => e.target.select()}
              onChange={(e) => setAttr({ ...attr, price: e.target.value })}
              value={attr.price}
              variant='standard'
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <MDTypography variant='body'>บาท</MDTypography>
                  </InputAdornment>
                ),
                inputProps: {
                  className: 'text-right',
                  autoComplete: 'off',
                },
              }}
            />
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderUnitInfo = () => {
    return (
      <MDBox className='card' p={2} mt={2}>
        <MDTypography variant='h6' mb={3}>
          หน่วยนับ
        </MDTypography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MDSelect
              label='หน่วยนับ *'
              labelDefault={t(`element.please_select`)}
              data={cboUnit}
              value={attr.unit_id}
              onChange={(e) => setAttr({ ...attr, unit_id: e.target.value })}
              inputProps={{
                autoComplete: 'off',
                readOnly: attr.change_unit === 'N',
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <MDSelect
              label='หน่วยเติม'
              labelDefault={t(`element.please_select`)}
              data={cboUnit}
              value={attr.unitadd_id}
              onChange={(e) => setAttr({ ...attr, unitadd_id: e.target.value })}
              inputProps={{
                autoComplete: 'off',
                readOnly: attr.change_unit === 'N',
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <MDSelect
              label='หน่วยซื้อ'
              labelDefault={t(`element.please_select`)}
              data={cboUnit}
              value={attr.unitbuy_id}
              onChange={(e) => setAttr({ ...attr, unitbuy_id: e.target.value })}
              inputProps={{
                autoComplete: 'off',
                readOnly: attr.change_unit === 'N',
              }}
            />
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderEtcInfo = () => {
    return (
      <MDBox className='card' p={2} mb={2}>
        <MDTypography variant='h6' mb={3}>
          อื่น ๆ
        </MDTypography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MDCheckbox
              label='สามารถซื้อได้'
              checked={attr.active_buy === 'Y'}
              onChange={(e) => setAttr({ ...attr, active_buy: e.target.checked ? 'Y' : 'N' })}
            />
          </Grid>
          <Grid item xs={12}>
            <MDCheckbox
              label='ตรวจสอบปริมาณ'
              checked={attr.check_stock === 'Y'}
              onChange={(e) => setAttr({ ...attr, check_stock: e.target.checked ? 'Y' : 'N' })}
            />
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderStockInfo = () => {
    return attr.check_stock === 'Y' ? (
      <MDBox className='card' p={2} mb={2}>
        <MDTypography variant='h6' mb={3}>
          ปริมาณแจ้งเตือน
        </MDTypography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MDInput
              label='ปริมาณขั้นต่ำ'
              onFocus={(e) => e.target.select()}
              onChange={(e) => setAttr({ ...attr, min_stock: e.target.value })}
              value={attr.min_stock}
              variant='standard'
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <MDTypography variant='body'>{attr.unit_name}</MDTypography>
                  </InputAdornment>
                ),
                inputProps: {
                  className: 'text-right',
                  autoComplete: 'off',
                },
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <MDInput
              label='ปริมาณสูงสุด'
              onFocus={(e) => e.target.select()}
              onChange={(e) => setAttr({ ...attr, max_stock: e.target.value })}
              value={attr.max_stock}
              variant='standard'
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <MDTypography variant='body'>{attr.unit_name}</MDTypography>
                  </InputAdornment>
                ),
                inputProps: {
                  className: 'text-right',
                  autoComplete: 'off',
                },
              }}
            />
          </Grid>
        </Grid>
      </MDBox>
    ) : null;
  };

  const renderTypeInfo = () => {
    return (
      <MDBox className='card' p={2}>
        <MDTypography variant='h6' mb={3}>
          ประเภท
        </MDTypography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MDSelect
              label='ยี่ห้อ'
              labelDefault={t(`element.please_select`)}
              data={cboBrand}
              value={attr.brand_id}
              onChange={(e) => setAttr({ ...attr, brand_id: e.target.value })}
              inputProps={{
                autoComplete: 'off',
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <MDSelect
              label='หมวดหมู่'
              labelDefault={t(`element.please_select`)}
              data={cboCat}
              value={attr.cat_id}
              onChange={(e) => setAttr({ ...attr, cat_id: e.target.value })}
              inputProps={{
                autoComplete: 'off',
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <MDSelect
              label='หมวดหมู่ย่อย'
              labelDefault={t(`element.please_select`)}
              data={cboSubCat}
              value={attr.subcat_id}
              onChange={(e) => setAttr({ ...attr, subcat_id: e.target.value })}
              inputProps={{
                autoComplete: 'off',
              }}
            />
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderThaiInfo = () => {
    return (
      <MDBox className='card' p={2}>
        <MDTypography variant='h6' mb={3}>
          ข้อมูลวัตถุดิบ
        </MDTypography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MDInput
              label='ชื่อสินค้า *'
              onChange={(e) => setAttr({ ...attr, name: e.target.value })}
              value={attr.name}
              variant='standard'
              fullWidth
              inputProps={{
                autoComplete: 'off',
              }}
            />
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderAddInfo = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} xl={3}>
          {renderProductInfo()}
          {renderPriceInfo()}
        </Grid>
        <Grid item xs={12} sm={6} xl={3}>
          {renderThaiInfo()}
        </Grid>
        <Grid item xs={12} sm={6} xl={3}>
          {renderTypeInfo()}
          {renderUnitInfo()}
        </Grid>
        <Grid item xs={12} sm={6} xl={3}>
          {renderEtcInfo()}
          {renderStockInfo()}
        </Grid>
      </Grid>
    );
  };

  const renderEditInfo = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} xl={3}>
          {renderProductInfo()}
        </Grid>
        <Grid item xs={12} sm={6} xl={3}>
          {renderThaiInfo()}
        </Grid>
        <Grid item xs={12} sm={6} xl={3}>
          {renderTypeInfo()}
          {renderUnitInfo()}
        </Grid>
        <Grid item xs={12} sm={6} xl={3}>
          {renderEtcInfo()}
          {renderStockInfo()}
        </Grid>
      </Grid>
    );
  };

  const renderAdd = () => {
    return (
      <Dialog open={modalAdd} maxWidth='xxl' keepMounted aria-describedby='dialog-add' fullWidth>
        <DialogTitle>
          {t(`element.add`)}
          <IconButton
            aria-label='close'
            onClick={() => setModalAdd(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox>{renderAddInfo()}</MDBox>
        </DialogContent>
        <DialogActions>
          {confirm ? (
            <Grid container>
              <Grid item xs={6}>
                <MDButton variant='text' color='error' onClick={() => setConfirm(false)}>
                  <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                </MDButton>
              </Grid>
              <Grid item xs={6} display='flex' justifyContent='flex-end'>
                <MDButton variant='outlined' color='success' onClick={add}>
                  <Icon>save</Icon>&nbsp;{t(`element.saveconfirm`)}
                </MDButton>
              </Grid>
            </Grid>
          ) : (
            <MDButton variant='text' color='info' onClick={addConfirm}>
              <Icon>save</Icon>&nbsp;{t(`element.save`)}
            </MDButton>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  const renderImage = () => {
    return (
      <Grid container spacing={2} sx={{ minHeight: 500 }}>
        <Grid item xs={12}>
          <MDBox mt={2} display='flex' justifyContent='end'>
            <ProductUpload uploadData={upload} />
          </MDBox>
        </Grid>
        <Grid item xs={12}>
          <MDBox>
            <Grid container spacing={2}>
              {image.map((item) => (
                <Grid key={item.id} item xs={12} md={4} xl={3}>
                  <Paper sx={{ p: 2 }} variant='outlined'>
                    <MDBox
                      component='img'
                      src={item.image}
                      alt={attr.name}
                      borderRadius='lg'
                      shadow='sm'
                      width='100%'
                      height='100%'
                      position='relative'
                      zIndex={10}
                    />
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </MDBox>
        </Grid>
      </Grid>
    );
  };

  const renderNavigate = () => {
    return (
      <Card sx={{ p: 2 }}>
        <Grid container>
          <Grid item xs={6}>
            <NavLink to={`/${mod}`}>
              <MDButton variant='contained' color='dark'>
                <Icon>arrow_back</Icon>&nbsp;{t(`element.back`)}
              </MDButton>
            </NavLink>
          </Grid>
          {navigate.first === '' ? null : (
            <Grid item xs={6}>
              <MDBox display='flex' justifyContent='flex-end' gap={1}>
                <NavLink to={`/${mod}/${navigate.first}`}>
                  <MDButton
                    variant='contained'
                    color='dark'
                    iconOnly
                    disabled={navigate.first === id}
                  >
                    <Icon>first_page</Icon>
                  </MDButton>
                </NavLink>
                <NavLink to={`/${mod}/${navigate.prev}`}>
                  <MDButton
                    variant='contained'
                    color='dark'
                    iconOnly
                    disabled={navigate.prev === id}
                  >
                    <Icon>navigate_before</Icon>
                  </MDButton>
                </NavLink>
                <NavLink to={`/${mod}/${navigate.next}`}>
                  <MDButton
                    variant='contained'
                    color='dark'
                    iconOnly
                    disabled={navigate.next === id}
                  >
                    <Icon>navigate_next</Icon>
                  </MDButton>
                </NavLink>
                <NavLink to={`/${mod}/${navigate.last}`}>
                  <MDButton
                    variant='contained'
                    color='dark'
                    iconOnly
                    disabled={navigate.last === id}
                  >
                    <Icon>last_page</Icon>
                  </MDButton>
                </NavLink>
              </MDBox>
            </Grid>
          )}
        </Grid>
      </Card>
    );
  };

  const renderOpen = () => {
    return (
      <MDBox mb={7}>
        <Navbar route={[t(`menu.product`), `${attr.sku} : ${attr.name}`]} />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {renderNavigate()}
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Card sx={{ p: 2 }}>
              <MDBox sx={{ width: '100%' }}>
                <MDBox>
                  <Tabs value={tab} onChange={(e, v) => setTab(v)} aria-label='tabs-addedit'>
                    <Tab label={t(`element.info`)} />
                    <Tab label='รูปภาพ' />
                  </Tabs>
                </MDBox>
                <TabPanel value={tab} index={0}>
                  <Grid container>
                    <Grid item xs={12}>
                      {renderEditInfo()}
                      {confirm ? (
                        <Grid container mt={3}>
                          <Grid item xs={6}>
                            <MDButton
                              variant='outlined'
                              color='error'
                              onClick={() => setConfirm(false)}
                            >
                              <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                            </MDButton>
                          </Grid>
                          <Grid item xs={6} display='flex' justifyContent='flex-end'>
                            <MDButton variant='gradient' color='success' onClick={edit}>
                              <Icon>save</Icon>&nbsp;{t(`element.saveconfirm`)}
                            </MDButton>
                          </Grid>
                        </Grid>
                      ) : (
                        <Grid container mt={3}>
                          <Grid item xs={12} display='flex' justifyContent='flex-end' gap={1}>
                            <MDButton variant='outlined' color='success' onClick={edit}>
                              <Icon>save</Icon>&nbsp;{t(`element.save`)}
                            </MDButton>
                          </Grid>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </TabPanel>
                <TabPanel value={tab} index={1}>
                  {renderImage()}
                </TabPanel>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderPage = () => {
    if (id === undefined) return renderList();
    return renderOpen();
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    init();
  }, [id]);

  return (
    <DashboardLayout>
      {renderPage()}
      {renderAdd()}
      <Footer />
      {renderLoading()}
      {notify}
    </DashboardLayout>
  );
}

export default ProductRawmat;
